import React, { useEffect, useState } from "react";
import * as R from "ramda";
import { Row } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { push, goBack } from "connected-react-router";
import generateAction from "../../../utils/action-helpers";
import { PENDING, AUTOMATIC, CONCILIATED, DETAIL } from "../../../state/actions";
import Layout from "../../ui/layout";
import Breadcrumb from "../../ui/breadcrumb";
import ErrorPage from "../../ui/error";
import Loader from "../../ui/loader";
import Proposals from "./proposal-selection";
import errorGreen from "../../../assets/img/error-green.png";
import "./css/index.scss";
import { accountingKeySign, majorAccountSign } from "../../../utils/sap-mapper";
import TooltipButton from "../../ui/tooltip-button";
import Transfer from "./transfer";
import NoClient from "./no-client";
import ProposalDetails from "./proposal-details";
import Calculator from "./calculator";
import { usePageView, fireEvent } from "../../../utils/google-analytics-handler";
import MultipleResume from "./multiple-resume";
import { mapper } from "./transfer-table";
import Disclaimer from "../../ui/disclaimer";
import removeIcon from "../../../assets/img/shredder.svg";

export const calculateCurency = currency => {
  let result;
  switch (currency) {
    case "USD":
      result = "$";
      break;
    case "GBP":
      result = "£";
      break;
    case "COP":
      result = "C$";
      break;
    case "AED":
      result = "DH";
      break;
    case "BRL":
      result = "R$";
      break;
    default:
      result = "€";
  }
  return result;
};
const ReconciliationDetail = () => {
  usePageView("/reconciliation-detail");
  const [openedDrawer, setOpenedDrawer] = useState(false);
  const [manualTercero, setManualTercero] = useState("");
  const [manualName, setManualName] = useState("");
  const [visibleDelete, setVisibleDelete] = useState(false);
  const {
    pending: { loading: loadingPending, error: errorPending, pending },
    automatic: { loading: loadingAutomatic, error: errorAutomatic, prevalidated },
    clients,
    detail: {
      selectedProposal,
      manualManagement,
      modified,
      loading,
      error,
      transfer,
      proposals,
      clientItems,
      multipleClients
    },
    router,
    user: { current }
  } = useSelector(state => state);
  const currency = transfer ? transfer.currency : "EUR";
  const pages = [{ name: "Conciliaciones", path: "/", active: true }];
  if (current.role === "Admin")
    pages.push({ name: "Administración", path: "/admin", active: false });

  const pathname = router.location.pathname.split("/");

  const kukey = Number(pathname[2]);
  const record = Number(pathname[3]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!loadingPending && !errorPending && !pending) {
      dispatch(generateAction(PENDING.FETCH));
    }
  }, [pending, dispatch, loadingPending, errorPending]);

  useEffect(() => {
    if (!loadingAutomatic && !errorAutomatic && !prevalidated) {
      dispatch(generateAction(AUTOMATIC.FETCH));
    }
  }, [prevalidated, dispatch, loadingAutomatic, errorAutomatic]);

  useEffect(() => {
    if (Number.isInteger(kukey) && Number.isInteger(record)) {
      if (!transfer && pending && prevalidated) {
        dispatch(generateAction(DETAIL.SEARCH_TRANSFER, { kukey, record }));
      } else {
        dispatch(generateAction(DETAIL.GET_PROPOSALS, { kukey, record }));
      }
    }
  }, [kukey, record, transfer, pending, prevalidated, dispatch]);


  const actions = [
    {
      name: "Volver a atrás",
      action: () => {
        dispatch(generateAction(PENDING.FETCH));
        dispatch(generateAction(AUTOMATIC.FETCH));
        dispatch(generateAction(CONCILIATED.FETCH));
        dispatch(goBack());
      },
      tooltip: "Volver a cargar"
    }
  ];
  if (error)
    return (
      <ErrorPage
        title="Error en el detalle de conciliciones"
        subtitle="Oopps. Ha habido un error"
        text="Inténtelo de nuevo más tarde y si el error persiste contacte con el CSU"
        image={errorGreen}
        email={current.email}
        role={current.role}
        pages={pages}
        actions={actions}
      />
    );
  if (loading || loadingPending || loadingAutomatic || !transfer)
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <Loader />
      </div>
    );

  const currencyText = currency ? calculateCurency(currency) : "€";
  const noProposal = Number.isNaN(selectedProposal) || selectedProposal === -1;
  const noManual = !manualManagement || R.isEmpty(manualManagement);
  const selectedProposalObject = !noProposal && proposals ? proposals[selectedProposal] : null;
  let selectedAmount = 0;

  if (selectedProposalObject && clientItems) {
    const allClientItems = [
      ...clientItems,
      ...multipleClients.flatMap(x => x.clientItems.map(x => ({ ...x, selected: true })))
    ];
    allClientItems.forEach(item => {
      if (item.selected)
        selectedAmount +=
          item.CO_LOCAL_CURRENCY === currency ? item.AM_LOCAL_CURRENCY : item.AM_FOREIGN_CURRENCY;
    });
  }

  if (manualManagement) {
    const allManuelManagement = [
      ...manualManagement,
      ...multipleClients.flatMap(x => x.manualManagement)
    ];
    allManuelManagement.forEach(item => {
      const sign = item.accountingKey
        ? accountingKeySign(item.accountingKey)
        : majorAccountSign(item.customer);
      selectedAmount += item.amount * sign;
    });
  }
  selectedAmount = Number(selectedAmount).toFixed(2);

  const selectProposal = index => {
    dispatch(
      generateAction(DETAIL.GET_ITEMS, {
        tercero: proposals[index].tercero
      })
    );
    dispatch(generateAction(DETAIL.SET_SELECTED_PROPOSAL, index));
  };
  const manualProposal = ({ value, label }, index) => {
    dispatch(
      generateAction(DETAIL.GET_ITEMS, {
        tercero: value
      })
    );
    setManualTercero(value);
    setManualName(label);
    if (selectedProposal !== index) {
      dispatch(generateAction(DETAIL.SET_SELECTED_PROPOSAL, index));
    }
  };
  const toggleSelect = itemObject =>
    dispatch(generateAction(DETAIL.MODIFY_ITEMS_SELECTION, { itemObject }));

  const acceptProposal = () =>
    dispatch(
      generateAction(PENDING.ACCEPT, {
        id: selectedProposalObject.id
      })
    );

  let modifiedProposal = {
    items: [],
    paymentsClient: [],
    paymentsCount: [],
    transfers: [{ kukey, record }]
  };
  if (selectedProposalObject && selectedProposalObject.id === -1) {
    selectedProposalObject.tercero = manualTercero;
    selectedProposalObject.name = manualName;
  }
  let tercero = selectedProposalObject ? selectedProposalObject.tercero : null;
  let society = "-";
  let division = "-";
  let ceco = "";
  if (modified) {
    const totalManualManagement = [
      ...manualManagement,
      ...multipleClients.flatMap(x => x.manualManagement)
    ];
    totalManualManagement.forEach(manual => {
      ({ customer: tercero, society, division, ceco } = manual);
      if (ceco) {
        modifiedProposal.paymentsCount = [
          ...modifiedProposal.paymentsCount,
          {
            ...manual,
            majorAccount: manual.customer
          }
        ];
      } else {
        modifiedProposal.paymentsClient = [...modifiedProposal.paymentsClient, manual];
      }
    });

    if (selectedProposalObject) {
      const totalClientItems = [
        ...clientItems.filter(x => x.selected),
        ...multipleClients.flatMap(x => x.clientItems)
      ];
      totalClientItems.forEach(
        ({
          CO_SOCIETY: itemSociety,
          ID_CUSTOMER: customer,
          QT_POSITION: position,
          ID_PERIOD: year,
          CO_PERIOD_VARIANT: period,
          CO_DOCUMENT_NUMBER: documentParam,
          QT_EXPIRATION_POSITION: expiration
        }) => {
          const item = {
            society: itemSociety,
            customer,
            year,
            period,
            document: documentParam,
            position,
            expiration
          };
          modifiedProposal.items.push(item);
        }
      );
    }
    if (!R.isEmpty(modifiedProposal.items)) {
      ({ tercero, society, division } = selectedProposalObject);
    }
    modifiedProposal = { ...modifiedProposal, tercero, society, division };
  }

  const createProposal = () => dispatch(generateAction(PENDING.CONCILE, modifiedProposal));
  const isExact = (transfer.amount ? transfer.amount.toFixed(2) : "0.00") === selectedAmount;
  const handleAddTransferToProposal = () => {
    const toTransferTercero = clients.selectedClient.value;
    const selectedTransfers = clientItems
      .filter(x => x.selected)
      .map(x => ({ ...x, selected: false, sapCode: toTransferTercero }));
    dispatch(
      generateAction(DETAIL.ADD_TRANSFER_TO_PROPSAL, {
        clientItems: selectedTransfers,
        manualManagement: manualManagement.map(x => ({
          ...x,
          selected: false,
          sapCode: toTransferTercero
        })),
        tercero: toTransferTercero,
        label: clients.selectedClient.label
      })
    );
    manualManagement.forEach((_, i) => dispatch(generateAction(DETAIL.REMOVE_MANUAL, i)));
  };
  const handleTransferToProposalChange = newValues => {
    dispatch(generateAction(DETAIL.REMOVE_TRANSFER_TO_PROPSAL, newValues));
    newValues.clientItems.map(mapper).forEach(x => toggleSelect(x.itemObject));
  };
  const handleDelete = () => {
    dispatch(generateAction(PENDING.DELETE_TRANSFER, { kukey, record }));
    dispatch(goBack());
  };
  const canEdit = current.role !== "Viewer" && selectedProposalObject;
  return (
    <Layout email={current.email} role={current.role} pages={pages}>
      <Breadcrumb
        elements={[
          { name: "CPA", active: false },
          { name: "Conciliaciones", active: false, action: () => dispatch(push("/")) },
          { name: "Detalle de conciliación", active: true, action: () => {} }
        ]}
      />
      <h2>Propuestas de conciliación</h2>
      <Row>
        <Transfer
          date={transfer.date}
          accountNumber={transfer.accountNumber}
          name={transfer.name}
          society={transfer.society}
          division={transfer.division}
        />
        <Proposals
          addManual={() => setOpenedDrawer(true)}
          noProposal={noProposal}
          proposals={proposals}
          selected={selectedProposal}
          select={selectProposal}
          customSelect={(manual, index) => manualProposal(manual, index)}
        />
      </Row>
      <Row>
        <div className="col-12">
          <Calculator
            isExact={isExact}
            selectedAmount={selectedAmount}
            amount={transfer ? transfer.amount : 0}
            currency={currencyText}
          />
        </div>
      </Row>
      {multipleClients.length > 0 && (
        <Row>
          <MultipleResume
            currency={currency}
            multipleClients={multipleClients}
            onDataChange={handleTransferToProposalChange}
          />
        </Row>
      )}
      <Row>
        <div className="col-12">
          <ProposalDetails
            noManual={noManual}
            noProposal={noProposal}
            modified={modified}
            clientItems={clientItems}
            selectedProposalObject={selectedProposalObject}
            selectedProposal={selectedProposal}
            currency={currency}
            manualManagement={manualManagement}
            canEdit={canEdit}
            toggleSelect={toggleSelect}
            onClick={() => setOpenedDrawer(true)}
            addTransfersToProposal={handleAddTransferToProposal}
            selectedTransfer={multipleClients
              .flatMap(x => x.clientItems)
              .map(x => x.CO_DOCUMENT_NUMBER)}
          />
          <div className="d-flex justify-content-between">
            <div className="buttons-set">
              <TooltipButton
                buttonClassName=" btn cp-btn__deleted cp-btn__large"
                onClick={() => setVisibleDelete(true)}
                buttonText="Eliminar"
                tooltipText="Salir del detalle"
              />
            </div>

            <div className="buttons-set text-center">
              <TooltipButton
                buttonClassName="btn cp-btn cp-btn__large"
                onClick={() => {
                  dispatch(goBack());
                  fireEvent("ConciliationProposal", "CancelDetail");
                }}
                buttonText="Cancelar"
                tooltipText="Salir del detalle"
              />
              <TooltipButton
                buttonClassName="btn cp-btn__primary cp-btn__large"
                disabled={!isExact || current.role === "Viewer"}
                onClick={modified ? createProposal : acceptProposal}
                buttonText="Conciliar"
                tooltipText="Aprobar propuesta de conciliación"
              />
            </div>
            <div className="empty-box" />
          </div>
        </div>
      </Row>
      <NoClient
        currency={currency}
        close={() => setOpenedDrawer(false)}
        open={openedDrawer}
        canEdit={canEdit}
        sapCode={tercero}
        society={transfer ? transfer.society : null}
        division={transfer ? transfer.division : null}
      />
      <Disclaimer
        icon={<img src={removeIcon} alt="Eliminar partida" />}
        title="Eliminar transferencia"
        text="¿Desea eliminar la transferencia?. Esta acción no se puede deshacer."
        visible={visibleDelete}
        acepptButtonText="Eliminar"
        cancelButtonText="Cancelar"
        onCancel={() => setVisibleDelete(false)}
        onAccept={() => {
          setVisibleDelete(false);
          handleDelete();
        }}
      />
    </Layout>
  );
};

export default ReconciliationDetail;
